import React from "react";
import PropTypes from "prop-types";

// core components
import LoadingSpinner from "core/LoadingSpinner";

// exposed components
export { HeroAsset } from "./components/HeroAsset";
export { Sidebar } from "./components/Sidebar/index";
export { DownloadButtons } from "./components/Sidebar/Buttons/DownloadButtons";

// components
import AssetDownloadContent from "./AssetDownloadContent";

const AssetDownload = props => {
    const { asset } = props;

    // asset might be `null` while awaiting apollo, we only want to start this party when provided with full asset object
    return !asset || !asset.id ? (
        <LoadingSpinner />
    ) : (
        <AssetDownloadContent {...props} />
    );
};

export default AssetDownload;

// prop-types
AssetDownload.propTypes = {
    assetType: PropTypes.string.isRequired,
    asset: PropTypes.object
};
